__webpack_require__.p = "https://kauranmm.personal.dynamic-ads.video.amazon.dev/";